import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { TypographyDDS } from '../../common/Typography/TypographyDDS'
import pallete from '../../../global/newPallete'

export interface Distribution {
  name?: string
  value: number
  color: string
}

export interface DistributionBarProps {
  distributions: Distribution[]
  rounded?: boolean
  height?: number
}

const SFDistributionBar: React.FC<DistributionBarProps> = ({
  distributions,
  rounded = false,
  height = 24
}) => {
  const totalValue = distributions.reduce((sum, d) => sum + d.value, 0)

  return (
    <div
      className={`w-full flex items-center overflow-hidden ${
        rounded ? 'rounded' : ''
      }`}
      style={{ height: `${height}px` }}
    >
      {totalValue === 0 ? (
        <div className='flex-1 bg-gray-300 h-[100%] ' />
      ) : (
        distributions.map((distribution, index) => {
          const percentage = (distribution.value / totalValue) * 100
          return (
            <Tooltip
              key={index}
              arrow
              title={
                distribution.name ? (
                  <TypographyDDS.Paragraph
                    size='para'
                    color={pallete.colors.textDark4}
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {distribution.name} – {percentage.toFixed(2)}%
                  </TypographyDDS.Paragraph>
                ) : (
                  ''
                )
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: '#f9f9f9',
                    color: '#000000',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    fontSize: '14px',
                    fontWeight: 400,
                    maxWidth: '700px',
                    whiteSpace: 'nowrap',
                    padding: '8px !important'
                  }
                },
                arrow: {
                  sx: {
                    color: '#f9f9f9'
                  }
                }
              }}
            >
              <div
                className='h-full'
                style={{
                  backgroundColor: distribution.color,
                  flexBasis: `${percentage}%`,
                  minWidth: percentage > 0 ? '2px' : '0px'
                }}
              />
            </Tooltip>
          )
        })
      )}
    </div>
  )
}

export default SFDistributionBar
